export enum EntityType {
    Work = "Works",
    Products = "Products",
    Agreements="Agreements"
}
